export default "__VITE_ASSET__Dp0v_W$4__"